/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import ServiceRegistry from "bundle/util/ServiceRegistry";
import React from "react";
import { observer } from "mobx-react";
import { defaultTheme, DialogContainer, Provider } from "@adobe/react-spectrum";
import LegalDialog from "../LegalDialog";
import AnalyticsConstants from "../../../../../../constants/AnalyticsConstants";
import { onLegalDialogClose } from "./LegalDialogCommonFunctions";

// The following component will be removed when AJS fixes the issue with the legal dialog

const NormalLegalDialog = observer(() => {
    const appStore = ServiceRegistry.getService("AppStore");
    const analyticsProviderService = ServiceRegistry.getService("AnalyticsProviderService");
    return (
        <Provider theme={ defaultTheme } colorScheme="light">
            <DialogContainer
                onDismiss={ () => { appStore.setLegalDialogOpen(false); } }
                type={ appStore.isSizedPreset && !appStore.inFullScreen ? "fullscreenTakeover" : "modal" }
            >
                {
                    appStore.legalDialogOpen
                    && (
                        <LegalDialog
                            onConfirm={ () => {
                                analyticsProviderService.sendEvent(AnalyticsConstants.LEGAL_NOTICES_CLOSE);
                                onLegalDialogClose();
                            } }
                            onEscapeKeyDown={ onLegalDialogClose }
                        />
                    )
                }
            </DialogContainer>
        </Provider>
    );
});

export default NormalLegalDialog;
